export const copyToClipboard = (element: HTMLElement | string) =>
    navigator.clipboard.writeText(
        typeof element === 'string'
            ? element
            : element.innerText
    );
